import { Component, OnInit } from "@angular/core";
import { IonInput, ModalController } from "@ionic/angular";
import { environment } from "src/environments/environment";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { first } from 'rxjs/operators';
import firebase from "firebase/app";
//Services
import { StorageService } from "src/app/services/storage/storage.service";
import { AuthService } from "src/app/services/auth/auth.service";
import { RouterService } from "src/app/services/router/router.service";
import { LoaderService } from "src/app/services/loader/loader.service";
import { ExceptionsService } from "src/app/exceptions/exceptions.service";
import { AlertService } from "src/app/services/alert/alert.service";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { TagsService } from "src/app/services/tags/tags.service";
import { EmblueService } from 'src/app/services/emblue/emblue.service';
import { FcmService } from 'src/app/services/fcm/fcm.service';
import { UserService } from "src/app/services/user/user.service";
import { RemoteConfigService } from "src/app/services/remote-config/remote-config.service";

@Component({
  selector: "app-change-phone-otp",
  templateUrl: "./change-phone-otp.page.html",
  styleUrls: ["./change-phone-otp.page.scss"],
})
export class ChangePhoneOtpPage implements OnInit {
  confirmationResult: any;
  LOADER_ID = "otp";
  messageError: Promise<string>;
  phoneLogin = false;
  flatActivateResendOtp: boolean;
  titleOtp: string[];
  animationDuration = 60000;
  renderOnClick = false;
  public phoneToRegister;
  token: any;
  tokenPush: any;
  recaptchaVerifier;
  verification;

  constructor(
    private storageService: StorageService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private routerService: RouterService,
    private loaderService: LoaderService,
    private exceptionService: ExceptionsService,
    public languageService: LanguagesService,
    private tagsService: TagsService,
    private emblueService: EmblueService,
    private fcmService: FcmService,
    public userService: UserService,
    public alertService: AlertService,
    public remoteConfig: RemoteConfigService,
    private modalController: ModalController
  ) { }

  otpForm = this.formBuilder.group({
    code1: ["", Validators.required],
    code2: ["", Validators.required],
    code3: ["", Validators.required],
    code4: ["", Validators.required],
    code5: ["", Validators.required],
    code6: ["", Validators.required],
  });

  ngOnInit() {
    this.tagsService.setEventTag('otp', 'register_otp_phone_screen_viewed', true, false, 'phone')
    this.authService.prepareRecaptcha("phone-change-recaptcha");
    this.recaptchaVerifier = this.authService.recaptchaVerifier;
    this.getPhoneFromStorage();
    this.configOtp();
  }

  configOtp() {
    this.titleOtp = this.getTextIUOtp.label_loading;
    this.renderOnClick = false;
    setTimeout(() => {
      this.titleOtp = this.getTextIUOtp.label_resend;
      this.animationDuration = 0;
      this.flatActivateResendOtp = true;
      this.renderOnClick = true;
    }, this.animationDuration);
  }

  async getPhoneFromStorage() {
    if (this.flatActivateResendOtp === false) return;
    this.flatActivateResendOtp = false;
    this.animationDuration = 60000;
    this.configOtp();
    this.loaderService.presentLoading(this.LOADER_ID);
    const phoneToRegister = await this.storageService.get("phone-to-change");
    this.phoneToRegister = phoneToRegister;
    if (phoneToRegister) {
      try {
        await this.verifyCredential();
        this.loaderService.cancelLoader(this.LOADER_ID);
      } catch (err) {
        this.loaderService.cancelLoader(this.LOADER_ID);
        this.exceptionService.renderError(err);
        this.routerService.redirectBack();
      }
    }
    this.loaderService.cancelLoader(this.LOADER_ID);
  }

  async verifyCredential() {
    const phone = await this.storageService.get("phone-to-change");

    var provider = new firebase.auth.PhoneAuthProvider();
    this.verification = provider.verifyPhoneNumber(phone, this.recaptchaVerifier).then(async function (verificationId) {
      return verificationId;
    }).catch(error => {
      console.log(error);
      
      this.alertService.showErrorAlert(error)
    });
  }

  async VerfiyAllNumberCodes() {
    this.loaderService.presentLoading(this.LOADER_ID);
    const userFirebase: firebase.User = await this.authService.getUSerInfoFromFirebase();
    const { code1, code2, code3, code4, code5, code6 } = this.otpForm.value;
    const finalCode = code1 + code2 + code3 + code4 + code5 + code6;
    var msj = "";
    try {
      this.verification.then((verificationId) => {
        return firebase.auth.PhoneAuthProvider.credential(verificationId, finalCode);
      }).then(async (credential) => {
        await userFirebase.updatePhoneNumber(credential);
        await this.changePhone();
        this.alertService.presentAlert("Número celular actualizado correctamente");
        this.modalController.dismiss(null, null, "changePhone");
        this.modalController.dismiss(null, null, "changePhoneOtp");
        this.routerService.redirect("app/profile/profile-detail");
        this.loaderService.cancelLoader(this.LOADER_ID);
        this.modalController.dismiss({
          'dismissed': true
        });
      }).catch(error => {
        switch (error.code) {
          case "auth/invalid-verification-code":
            msj = "Código de verificación incorrecto"
            break;
          case "auth/invalid-verification-id":
            msj = "Credencial Invalida"
            break;
          default: error
            msj = "El número que ingresó puede estar en uso u ocurrió un error inesperado."
            break;
        }
        this.loaderService.cancelLoader(this.LOADER_ID);
        this.modalController.dismiss(null, null, "changePhoneOtp");
        this.modalController.dismiss(null, null, "changePhone");
        this.alertService.showErrorAlert(msj);
      });
    } catch (error) {
      console.log('error');
      this.alertService.showErrorAlert(error)
    }

  }

  async changePhone() {
    this.loaderService.presentLoading(this.LOADER_ID);
    try {
      const phone = await this.storageService.get("phone-to-change");

      // Set phone token
      const tokenFB = await this.authService.callFbToken();
      await this.authService.linkPhoneOnGnx(tokenFB, phone);

      const tokenGnx = await this.authService.getAccessFromUsers(tokenFB);
      this.authService.setCurrentTokenGnx(tokenGnx);

      //Set phone user-info
      await this.userService.updateField("phone", phone);

      await this.saveTokenGNX(tokenGnx);
      this.loaderService.cancelLoader(this.LOADER_ID);
      this.loaderService.presentLoading(this.LOADER_ID);
    } catch (err) {
      this.tagsService.setEventTag('otp', 'login_page_error', true, false, 'phone')
      this.loaderService.cancelLoader(this.LOADER_ID);
      console.log(err);
      console.log('err', err);
      
      this.exceptionService.renderError(err);
    }
  }

  gotoNextField(nextElement, code: IonInput) {
    if (!code.value) return;
    let inputCode = Number(code.value);
    for (let i = 0; i <= 9; i++) {
      if (i === inputCode) {
        nextElement.setFocus();
        break;
      }
    }
  }
  async saveTokenGNX(tokenGNX: any) {
    this.loaderService.cancelLoader(this.LOADER_ID);
    if (tokenGNX.match) {
      await this.storageService.set("gnx-token", tokenGNX);
    }
    try {
      await this.emblue();
    } catch (error) {
      console.log("error emblu set", error);
    }
    return this.routerService.redirect("app/home");
  }

  get getTextIUOtp() {
    return this.languageService.textsIU.page_otp;
  }

  async emblue() {
    //console.log(" this.phoneToRegister: " ,  this.phoneToRegister );
    //let email = 'idcelular_' + this.phoneToRegister + '@nomail.com';
    await this.fcmService.getUserInfoUser().pipe(first()).subscribe((user: any) => {
      if (user) {
        this.emblueService.getToken().then(async (token: any) => {
          let user_email = (user.email) ? user.email : 'mobile_' + user.phone.trim() + '@nomail.com';
          this.token = token;
          this.tokenPush = this.fcmService.tokenFcm;
          var phone_user = this.emblueService.validationPhone(user.phone);
          let editCustomFields = "telefono_1:|:" + phone_user + ":|:1|||nombre:|:" + user.name + ":|:1|||apellido:|:" + user.lastnames + ":|:1|||id_contacto:|:" + user.gnxCredential1 + ":|:1|||email_secundario:|:" + user_email + ":|:1|||push_fb:|:" + this.tokenPush + ":|:1";
          //console.log("login editCustomFields", editCustomFields);
          //console.log("tokens",   this.token, " fcm: ", this.tokenPush);
          this.emblueService.setAssociatePushToEmail(user_email, this.token, this.fcmService.tokenFcm).then(data => {
            console.log("setAssociatePushToEmail", data);
            this.emblueService.setNewContact(user_email, editCustomFields, this.token).then(result => {
              console.log("setNewContact", result);
            });
          });
        });
      }
    });
  }
}
